import { responsive } from "./responsive";

export const asyncLibs = (lib, trigger, screen) => {
  const triggerElement = document.querySelector(trigger);

  if (screen ?? '') {
    document.addEventListener('RESPONSIVE_HAS_CHANGED', (event) => {
      if (!responsive.is(screen)) {
        asyncLibs(lib, trigger);
      }
    });
    return;
  }
  
  if (!triggerElement) return;
  return new Promise(() => {
    importLib(lib)
      .then((module) => {
        module.init();
      })
      .catch((handleError) => {
        console.error(`Error loading`, handleError);
      });
  })
};

export const importLib = (lib) => {
  return new Promise((resolve, reject) => {
    import(`../async/${lib}`)
      .then((module) => {
        resolve(module.default);
      })
      .catch((handleError) => {
        console.error(`Error loading`, handleError);
      });
  })
};